import React from 'react';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';
import SpecialCare from './SpecialCare';

const SpecialCareWrapper = () => {
    return (
        <ServicesChartsDataProvider
            module={{
                sectionTitle: 'Cuidados Especiais',
            }}
        >
            <SpecialCare />
        </ServicesChartsDataProvider>
    );
};

export default SpecialCareWrapper;
